import { Box } from '@mui/material'

import { Container, Title, Pills, TechStacks, TechLogo } from '../styled'
import { TestimonialContainer } from '../Testimonial/styled'
import { StyledSkeleton, DescriptionSkeleton, PillSkeleton, AvatarSkeleton } from './styled'

export default function Loading() {
  return (
    <Container>
      <Title>
        <StyledSkeleton variant="rectangular" width={240} />
      </Title>
      <Box component="div" display="flex" flexDirection="column" gap={2} mb={4}>
        <DescriptionSkeleton variant="rectangular" />
        <DescriptionSkeleton variant="rectangular" />
        <DescriptionSkeleton variant="rectangular" />
      </Box>
      <Pills>
        {[...Array(4)].map((_, index) => (
          <PillSkeleton key={index} />
        ))}
      </Pills>
      <TechStacks>
        {[...Array(4)].map((_, index) => (
          <TechLogo key={index}>
            <StyledSkeleton
              variant="rectangular"
              width={155}
              height={155}
              sx={{ borderRadius: '20%' }}
            />
          </TechLogo>
        ))}
      </TechStacks>
      <TestimonialContainer>
        <AvatarSkeleton variant="rectangular" sx={{ borderRadius: '50%', m: 2 }} />
        <DescriptionSkeleton variant="rectangular" height={200} />
      </TestimonialContainer>
    </Container>
  )
}
